module.exports = __webpack_public_path__ + "static/img/album_2.bc04811.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/album_2.png
// module id = 6wsM
// module chunks = 1